"use strict";

module.exports = function (config) {
  return config;
};


//////////////////
// WEBPACK FOOTER
// ./config/test/index.js
// module id = 2248
// module chunks = 0